<template>
    <div>
        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">

            <!-- Card stats -->
            <div v-if="selectedProfile == 'terminals' && accountId != null" class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Available Licenses"
                                type="gradient-green"
                                :sub-title="licenseStats"
                                icon="ni ni-basket"
                                class="mb-4 mb-xl-0">
                        <template slot="footer">
                            <span class="mr-2"> total licenses used </span>
                        </template>
                    </stats-card>
                </div>
            </div>

            <br> <br>
            <base-dropdown >
                <base-button slot="title" type="success" class="dropdown-toggle">
                    Internal Admin - {{ _.startCase(selectedProfile)}}
                </base-button>
                    <!-- <hr class="my-3"/> -->
                    <h6 class="heading-small text-muted ml-2 mt-1"> General </h6>
                    <a @click.prevent="setCurrentProfile('system_modules')" class="dropdown-item" href="#">System Modules</a>

                    <hr class="my-3"/>
                    <h6 class="heading-small text-muted ml-2"> Account Specific </h6>
                    <a @click.prevent="setCurrentProfile('account_management')" class="dropdown-item" href="#">Account Management</a>
                    <a @click.prevent="setCurrentProfile('custom_unique_fields')" class="dropdown-item" href="#">Custom Unique Fields</a>
                    <a @click.prevent="setCurrentProfile('terminals')" class="dropdown-item" href="#">Licensing</a>
                    <a @click.prevent="setCurrentProfile('payment_types')" class="dropdown-item" href="#">Payment Types</a>
                    <a @click.prevent="setCurrentProfile('pos_tracking_version')" class="dropdown-item" href="#">POS Tracking Version</a>
                    <a @click.prevent="setCurrentProfile('full_sync')" class="dropdown-item" href="#">Export Full Sync</a>
                    <a @click.prevent="setCurrentProfile('full_sync_status')" class="dropdown-item" href="#">Full Sync Status</a>
                    <a @click.prevent="setCurrentProfile('account_system_module')" class="dropdown-item" href="#">Account System Modules</a>
                    <!-- bryan -->
                    <a @click.prevent="setCurrentProfile('account_templates')" class="dropdown-item" href="#">Account Templates</a>
                    <a @click.prevent="setCurrentProfile('invoice_process_monitoring')" class="dropdown-item" href="#">Invoice Processing Monitoring</a>
                    <a @click.prevent="setCurrentProfile('reset_transactions')" class="dropdown-item" href="#">Reset Transactions</a>

                    <a @click.prevent="setCurrentProfile('inventory_recompute')" class="dropdown-item" href="#">Inventory Recompute Tool</a>
                    <a @click.prevent="setCurrentProfile('pos_database_recovery')" class="dropdown-item" href="#">POS Database Recovery</a>
                    <a @click.prevent="setCurrentProfile('jobs')" class="dropdown-item" href="#">Jobs</a>

                    <hr class="my-3"/>
                    <h6 class="heading-small text-muted ml-2"> Dynamic Forms </h6>
                    <a @click.prevent="setCurrentProfile('dynamic_forms')" class="dropdown-item" href="#">Generic</a>
                    <a @click.prevent="setCurrentProfile('terminal_settings')" class="dropdown-item" href="#">Terminal Settings</a>
                    <a @click.prevent="setCurrentProfile('terminal_template_settings')" class="dropdown-item" href="#">Terminal Template Settings</a>
            </base-dropdown>
        </base-header>

        <div v-if="selectedProfile == 'account_management'" class="container-fluid mt--7">
            <account-management></account-management>
        </div>

        <div v-if="selectedProfile == 'custom_unique_fields'" class="container-fluid mt--7">
            <custom-unique-fields></custom-unique-fields>
        </div>

        <div v-if="selectedProfile == 'terminal_template_settings'" class="container-fluid mt--7">
            <terminal-settings-view :headerType="1" :key="componentKey"></terminal-settings-view>
        </div>

        <div v-if="selectedProfile == 'terminal_settings'" class="container-fluid mt--7">
            <terminal-settings-view :headerType="2" :key="componentKey"></terminal-settings-view>
        </div>

        <div v-if="selectedProfile == 'system_modules'" class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                        <div class="card mb-3">
                          <div class="row no-gutters">
                            <div class="col-md-6" style="border-right: 1px solid #e0e0e0">
                              <div class="card-body">
                                <div v-if="selectedNode == null" class="row">
                                    <div class="col-md-8 no-gutters"><h2 class="card-title">Categories</h2></div>
                                    <div class="col-md-4 float-right"><button @click.prevent="newCateg('addCategory')" class="btn btn-sm btn-primary" style="border-radius: 24px; background-color: #0569FF; border:0px; width: 100%;">New Category</button></div>
                                </div>
                                <div v-else class="row">
                                    <div class="col-md-6 no-gutters"><h2 class="card-title">Categories</h2></div>
                                    <div class="col-md-3 float-right"><button @click.prevent="showDrawer('editCategory')" class="btn btn-sm btn-default" style="border-radius: 24px; border:0px; width: 100%;">Edit</button></div>
                                    <div v-if="selectedLevel < 3" class="col-md-3 float-right"><button @click.prevent="showDrawer('addCategory')" class="btn btn-sm btn-primary" style="border-radius: 24px; background-color: #0569FF; border:0px; width: 100%;">Add</button></div>
                                </div>

                                <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="visible">
                                    <div v-if="formId == 'editCategory'">
                                        <h6 class="heading-small text-muted mb-4">Edit Category</h6>
                                        <form>
                                            <base-input alternative="" label="Name" placeholder="" v-model="selectedTitle" input-classes="form-control"/>
                                            <base-input alternative="" label="Code" placeholder="" v-model="selectedCode" input-classes="form-control"/>
                                            <base-input alternative="" label="Reference Code" placeholder="" v-model="selectedRefCode" input-classes="form-control"/>
                                            <base-input v-if="selectedLevel > 1" alternative="" type=number label="Sequence No" placeholder="" v-model="selectedSequence" input-classes="form-control"/>
                                            <base-input v-if="selectedLevel > 2" alternative="" label="Icon" placeholder="" v-model="selectedIcon" input-classes="form-control"/>
                                            <base-input v-if="selectedLevel > 2" alternative="" label="Endpoint" placeholder="" v-model="selectedEndpoint" input-classes="form-control"/>
                                            <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                                                <button class="btn btn-danger" @click.prevent="deleteData">Delete</button>
                                                <button class="btn btn-success" @click.prevent="updateData">Update</button>
                                                <button class="btn" @click.prevent="onClose">Cancel</button>
                                            </div>
                                        </form>
                                    </div>
                                    <div v-else-if="formId == 'addCategory'">
                                        <h6 class="heading-small text-muted mb-4">Add Category</h6>
                                        <form>
                                            <!-- {{selectedLevel}} -->
                                            <base-input alternative="" label="Name" placeholder="" v-model="selectedTitle" input-classes="form-control"/>
                                            <base-input alternative="" label="Code" placeholder="" v-model="selectedCode" input-classes="form-control"/>
                                            <base-input alternative="" label="Reference Code" placeholder="" v-model="selectedRefCode" input-classes="form-control"/>
                                            <base-input v-if="selectedLevel != null" alternative="" type=number label="Sequence No" placeholder="" v-model="selectedSequence" input-classes="form-control"/>
                                            <base-input v-if="selectedLevel > 1" alternative="" label="Icon" placeholder="" v-model="selectedIcon" input-classes="form-control"/>
                                            <base-input v-if="selectedLevel > 1" alternative="" label="Endpoint" placeholder="" v-model="selectedEndpoint" input-classes="form-control"/>
                                            <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                                                <button class="btn btn-success" @click.prevent="createData">Add</button>
                                                <button class="btn" @click.prevent="onClose">Cancel</button>
                                            </div>
                                        </form>
                                    </div>
                                    <div v-else-if="formId == 'addModule'">
                                        <h6 class="heading-small text-muted mb-4">Add Module for {{selectedTitle}}</h6>
                                        <form>
                                            <base-input alternative="" label="Name" placeholder="" v-model="module.name" input-classes="form-control"/>
                                            <base-input alternative="" label="Code" placeholder="" v-model="module.code" input-classes="form-control"/>
                                            <base-input alternative="" label="Sequence No" type="number" placeholder="" v-model="module.sequence_no" input-classes="form-control"/>
                                            <base-input alternative="" label="Reference Code" placeholder="" v-model="module.reference_code" input-classes="form-control"/>
                                            <!-- {{selectedNode}}
                                            <base-input v-if="selectedNode.scopedSlots.code.includes('POS-PO')" alternative="" label="Authorization Group" placeholder="" v-model="module.auth_group" input-classes="form-control"/> -->
                                            <base-input alternative="" label="Description">
                                                <textarea rows="4" class="form-control" v-model="module.description"/>
                                            </base-input>
                                            <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                                                <button class="btn btn-success" @click.prevent="createModule">Add</button>
                                                <button class="btn" @click.prevent="onClose">Cancel</button>
                                            </div>
                                        </form>
                                    </div>
                                    <div v-else-if="formId == 'editModule'">
                                        <h6 class="heading-small text-muted mb-4">{{selectedModule.name}}</h6>
                                        <form style="padding-bottom: 5em;">
                                            <base-input alternative="" label="Name" placeholder="" v-model="selectedModule.name" input-classes="form-control"/>
                                            <base-input alternative="" label="Code" placeholder="" v-model="selectedModule.code" input-classes="form-control"/>
                                            <base-input alternative="" label="Sequence No" type="number" placeholder="" v-model="selectedModule.sequence_no" input-classes="form-control"/>
                                            <!-- <base-input alternative="" label="Reference Code" placeholder="" v-model="selectedModule.reference_code" input-classes="form-control"/> -->
                                            <base-input alternative="" label="Description">
                                                <textarea rows="4" class="form-control" v-model="selectedModule.description"/>
                                            </base-input>
                                            <ul v-if="system_modules.length > 0" class="list-group list-group-flush" style="width: 100%">
                                                <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            ACCESS RIGHTS
                                                        </div>
                                                        <div class="col-md-6">
                                                            <a-checkbox @change="onCheckAllChangeAccess" :checked="selectedAccessRights.length == 15" class="float-right"/>
                                                        </div>
                                                     </div>
                                                </li>

                                                <li class="list-group-item" style="font-size: 14px" v-for="accessRight in accessRights">
                                                     <div class="row">
                                                         <div class="col-md-6">
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{accessRight.name}}
                                                        </div>
                                                        <div class="col-md-6">
                                                            <a-checkbox data-id="system_module.name" @change="onCheckChangeAccess(accessRight.key)" :checked="selectedAccessRights.includes(accessRight.key)" class="float-right"/>
                                                        </div>
                                                     </div>
                                                </li>
                                            </ul>

                                            <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                                                <button class="btn btn-danger float-right" @click="deleteModule">Delete</button>
                                                <button class="btn btn-success float-right" @click.prevent="updateModule">Update</button>
                                                <button class="btn btn-secondary float-right" @click.prevent="onClose">Cancel</button>
                                            </div>
                                        </form>
                                    </div>

                                    <div v-else-if="formId == 'massAccessRights'">
                                        <h6 class="heading-small text-muted mb-4">ASSIGN ACCESS RIGHTS</h6>
                                        <form style="padding-bottom: 5em;">
                                            <ul v-if="system_modules.length > 0" class="list-group list-group-flush" style="width: 100%">
                                                <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            ACCESS RIGHTS
                                                        </div>
                                                        <div class="col-md-6">
                                                            <a-checkbox @change="onCheckAllChangeAccess" :checked="selectedAccessRights.length == 15" class="float-right"/>
                                                        </div>
                                                     </div>
                                                </li>

                                                <li class="list-group-item" style="font-size: 14px;" v-for="accessRight in accessRights" :key="accessRight.key">
                                                     <div class="row">
                                                         <div class="col-md-6">
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{accessRight.name}}
                                                         </div>
                                                        <div class="col-md-6">
                                                            <a-checkbox data-id="system_module.name" @change="onCheckChangeAccess(accessRight.key)" :checked="selectedAccessRights.includes(accessRight.key)" class="float-right"/>
                                                        </div>
                                                     </div>
                                                </li>
                                            </ul>

                                            <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                                                <button class="btn btn-success float-right" @click.prevent="updateModule">Assign</button>
                                                <button class="btn btn-secondary float-right" @click.prevent="onClose">Cancel</button>
                                            </div>
                                        </form>
                                    </div>

                                </a-drawer>


                                <a-input style="margin-bottom: 8px" placeholder="Search Categories" @change="onChange" />
                                <a-tree class="draggable-tree" :defaultExpandedKeys="expandedKeys" :expandedKeys="expandedKeys"
                                  :autoExpandParent="autoExpandParent" draggable @expand="onExpand" @select="onSelect" @dragenter="onDragEnter"
                                  @drop="onDrop" @check="onCheck" :treeData="gData">
                                    <template slot="title" slot-scope="{title}">
                                      <span v-if="title.indexOf(searchValue) > -1">
                                        {{title.substr(0, title.indexOf(searchValue))}}
                                        <span style="color: #f50">{{searchValue}}</span>
                                        {{title.substr(title.indexOf(searchValue) + searchValue.length)}}
                                      </span>
                                      <span v-else>{{title}} </span>
                                    </template>
                                </a-tree>

                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="card-body">
                                 <div class="row">
                                    <div class="col-md-8"><h2 class="card-title">Modules</h2></div>
                                    <div class="col-md-4 float-right"><button @click.prevent="showDrawer('addModule')" class="btn btn-sm btn-primary" style="border-radius: 24px; background-color: #0569FF; border: 0px; width: 100%;">New Module</button></div>

                                    <ul v-if="system_modules.length > 0" class="list-group list-group-flush" style="width: 100%">
                                        <li class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7">
                                            <div class="row">
                                                <div class="col-md-1">
                                                    <a-checkbox @change="onCheckAllChange" :checked="checkedValues.length == system_modules.length"/>
                                                </div>
                                                <div v-if="checkedValues.length > 0" class="col-md-6">
                                                    <!-- <small><a v-b-modal.modal-2>MOVE</a></small> -->
                                                </div>
                                                <div v-if="checkedValues.length > 0" class="col-md-2">
                                                    <small><a @click.prevent="massupdate('status','D')">DELETE</a></small>
                                                </div>
                                                <div v-if="checkedValues.length > 0" class="col-md-3">
                                                    <small><a @click.prevent="editModule('massAccessRights', null)">MANAGE ACCESS</a></small>
                                                </div>
                                                <!-- <div v-if="checkedValues.length > 0" class="col-md-4">
                                                    | &nbsp;&nbsp;
                                                    <small><a @click.prevent="massupdate('enabled',1)">ENABLE</a></small> &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <small><a @click.prevent="massupdate('enabled',0)">DISABLE</a></small>
                                                </div> -->
                                             </div>
                                        </li>
                                         <!-- eslint-disable-next-line -->

                                        <li class="list-group-item" style="font-size: 14px" v-for="system_module in system_modules" :key="system_module.id">
                                             <div class="row">
                                                <div class="col-md-6">
                                                    <a-checkbox data-id="system_module.name" @change="onCheckChange(system_module.id)" :checked="checkedValues.includes(system_module.id)">{{system_module.name}}</a-checkbox>
                                                    <br/>
                                                    <!-- <a @click.prevent="editModule('editModule', system_module)"><small class="float-right">OPTIONS</small></a> -->
                                                </div>
                                                <div class="col-md-6">
                                                    <a @click.prevent="editModule('editModule', system_module)"><small class="float-right">OPTIONS</small></a>
                                                </div>
                                                <!-- <div class="col-md-2">
                                                    <a-switch @change="toggleDetected" :data-id="system_module.id" :checked="system_module.enabled == 1"/>
                                                </div> -->
                                             </div>
                                        </li>

                                    </ul>
                                    <div v-else class="align-text: center;">
                                        <small>No modules to display</small>
                                    </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                </div>
            </div>
        </div>

        <div v-if="selectedProfile == 'terminals'" class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card mb-3">
                        <div class="row no-gutters">
                            <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                              <div class="card-body">
                                  <div v-if="currentProfile == 'terminals' || current_profile == 'payment_types'">
                                      <h6 class="heading-small text-muted mb-4">Account Filter</h6>
                                      <a-select v-model="accountId" showSearch placeholder="Select Account" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="handleSearch">
                                          <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                          <a-select-option v-for="option in accountOptions" :key="option.id" :value="option.id">{{option.account_name}}</a-select-option>
                                      </a-select>
                                      <!-- @keyup.enter="doFilter" v-model="filterText" -->
                                      <!-- <input type="text" class="form-control" placeholder="Search account name" v-model="accountFilter" @keyup.enter="doAccountFilter"> -->
                                  </div>
                                  <br/>
                                  <filter-bar @changeFilter="changeFilter"></filter-bar>
                              </div>
                            </div>

                            <div class="col-md-9">
                              <div class="card-body">
                                 <licenses-table @refreshPage="refreshPage" :accountId="accountId" :key="componentKey" @updateAvailableLicense="updateAvailableLicense"></licenses-table>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="selectedProfile == 'dynamic_forms'" class="container-fluid mt--7">
            <dynamic-form-view></dynamic-form-view>
        </div>

         <div v-if="selectedProfile == 'payment_types'" class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card mb-3">
                        <div class="row no-gutters">
                            <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                              <div class="card-body">
                                  <div v-if="currentProfile == 'payment_types'">
                                      <h6 class="heading-small text-muted mb-4">Account Filter</h6>
                                      <a-select v-model="accountId" showSearch placeholder="Select Account" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="handleSearch">
                                          <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                          <a-select-option v-for="option in accountOptions" :key="option.id" :value="option.id">{{option.account_name}}</a-select-option>
                                      </a-select>
                                  </div>
                                  <br/>
                                  <filter-bar @changeFilter="changeFilter"></filter-bar>
                              </div>
                            </div>

                            <div class="col-md-9">
                              <div class="card-body">
                                  <!-- Insert table of payment type -->
                                 <payment-types-table @refreshPage="refreshPage" :accountId="accountId" :key="componentKey"></payment-types-table>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="selectedProfile == 'pos_tracking_version'" class="container-fluid mt--7">
          <div class="row">
            <div class="col">
              <div class="card mb-3">
                <div class="row no-gutters">
                  <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                  <div class="card-body">
                    <div>
                      <base-input label="Account Selection:">
                        <a-select showSearch style="width: 100%" placeholder="" optionFilterProp="children" v-model="selectedAccount">
                          <a-select-option v-for="(account, index) in accounts" :key="index" :value="account.id">
                            {{account.account_name}}
                          </a-select-option>
                        </a-select>
                      </base-input>
                    </div>

                    <div>
                      <base-input label="Site:">
                        <a-select showSearch
                                    style="width: 100%"
                                    placeholder=""
                                    optionFilterProp="children"
                                    v-model="selectedSite">
                            <a-select-option v-for="(site, index) in sites"
                                            :key="index"
                                            :value="site.id">
                            {{site.name}}
                            </a-select-option>
                        </a-select>
                      </base-input>
                    </div>

                    <div>
                      <base-input label="Terminal:">
                        <a-select showSearch
                                  style="width: 100%"
                                  placeholder=""
                                  optionFilterProp="children"
                                  v-model="selectedTerminal">
                          <a-select-option v-for="(terminal, index) in terminals"
                                            :key="index"
                                            :value="terminal.id">
                            {{terminal.name}}
                          </a-select-option>
                        </a-select>
                      </base-input>
                    </div>
                  </div>
                  </div>

                  <div class="col-md-9">
                    <div class="card-body">
                      <!-- Insert table of payment type -->
                      <pos-tracking-version @refreshPage="refreshPage" :accountId="selectedAccount" :siteId="selectedSite" :terminalId="selectedTerminal" :key="componentKey"></pos-tracking-version>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="selectedProfile == 'full_sync'" class="container-fluid mt--7">
          <FullSync/>
        </div>

        <div v-if="selectedProfile == 'full_sync_status'" class="container-fluid mt--7">
          <FullSyncStatus/>
        </div>

        <div v-if="selectedProfile == 'account_system_module'" class="container-fluid mt--7">
          <AccountSystemModule/>
        </div>

        <!-- bryan -->
        <div v-if="selectedProfile == 'account_templates'" class="container-fluid mt--7">
          <AccountTemplates :headerType="2" :key="componentKey"/>
        </div>



        <div v-if="selectedProfile == 'invoice_process_monitoring'" class="container-fluid mt--7">
          <InvoiceProcessingMonitoring/>
        </div>

        <div v-if="selectedProfile == 'reset_transactions'" class="container-fluid mt--7">
          <ResetTransactions/>
        </div>
        
        <div v-if="selectedProfile == 'inventory_recompute'" class="container-fluid mt--7">
          <InventoryRecompute/>
        </div>

        <div v-if="selectedProfile == 'pos_database_recovery'" class="container-fluid mt--7">
          <PosDatabaseRecovery/>
        </div>

        <div v-if="selectedProfile == 'jobs'" class="container-fluid mt--7">
          <Jobs/>
        </div>
    </div>
</template>


<script>
import PaymentTypesTable from './Tables/AccountPaymentTypeTable.vue';
import LicensesTable from './Tables/LicensesTable.vue';
import ProfilesTable from './Tables/PosProfilesTable.vue';
import HTTPRequest from '../controllers/httpRequest.js';
import FilterBar from './FilterBar';
import TerminalSettingsView from './TerminalSettingsView.vue';
import DynamicFormView from './DynamicFormView.vue';
import AccountManagement from './Internal Admin/AccountManagement.vue';
import CustomUniqueFields from './Internal Admin/CustomUniqueFields.vue';
import PosTrackingVersion from './Tables/PosTrackingVersion.vue';
import FullSync from './Internal Admin/FullSync.vue';
import FullSyncStatus from './Internal Admin/FullSyncStatus.vue';
import AccountSystemModule from './Internal Admin/AccountSystemModule.vue';
import InvoiceProcessingMonitoring from './Internal Admin/InvoiceProcessingMonitoring.vue';
import ResetTransactions from './Internal Admin/ResetTransactions.vue';
import AccountTemplates from './Internal Admin/AccountTemplates.vue'
import InventoryRecompute from './Internal Admin/InventoryRecompute.vue'
import PosDatabaseRecovery from './Internal Admin/PosDatabaseRecovery.vue'
import Jobs from './Jobs.vue'

let gData = []
const dataList = []
const generateList = (data) => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i]
    const key = node.key
    dataList.push({ key, title: node.title })
    if (node.children) {
      generateList(node.children, node.key)
    }
  }
}

const getParentKey = (key, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some(item => item.key === key)) {
        parentKey = node.key
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children)
      }
    }
  }
  return parentKey
}

let node_ret = null
const getNode = function (key, tree)
{
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if(node.key == key){
       node_ret = node
    } else {
        if(node.children.length > 0){
            getNode(key, node.children)
        }
    }
  }
  return node_ret;
}

import { mapState, mapActions } from 'vuex';

export default {
    components: {
      ProfilesTable,
      FilterBar,
      LicensesTable,
      TerminalSettingsView,
      DynamicFormView,
      AccountManagement,
      PaymentTypesTable,
      CustomUniqueFields,
      PosTrackingVersion,
      FullSync,
      FullSyncStatus,
      AccountSystemModule,
      InvoiceProcessingMonitoring,
      ResetTransactions,
      InventoryRecompute,
      PosDatabaseRecovery,
      Jobs,
    //   bryan
      AccountTemplates
    },
  mounted: async function(){
    this.gData = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/tree_view', null)
    gData = this.gData
    generateList(gData)
  },
  computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        // ...mapState(['endPoint', 'currentProfile', 'parameters', 'serverType'])
    },
  data () {
    return {
      accountId: null,
      accounts: [],
      sites: [],
      terminals: [],
      selectedAccount: null,
      selectedSite: null,
      selectedTerminal: null,
      fetching: false,
      accountOptions: [],
      licenseStats: "",
      componentKey: 0,
      filterStatus: "",
      selectedModule: null,
      system_modules: [],
      module:{
          name: "",
          code: "",
          sequence_no:"",
          reference_code: "",
          supported_rights: ""
      }, checkedValues: [],
      expandedKeys: [],
      searchValue: '',
      autoExpandParent: true,
      gData,
      visible: false,
      formId: "",
      selectedNode: null,
      selectedLevel: null,
      selectedIcon: null,
      selectedSequence: null,
      selectedEndpoint: null,
      selectedKey: null,
      selectedTitle: "",
      selectedCode: "",
      selectedRefCode: "",
      accessRights: [ {name: 'View', key:'V'}, {name: 'Add', key: 'A'}, {name: 'Edit', key: 'W'}, {name: 'Delete', key: 'D'},
                      {name: 'Post', key: 'P'}, {name: 'Confirm', key: 'C'}, {name: 'Print', key: 'T'},
                      {name: 'Supervise', key: 'S'}, {name: 'Sensitive Info', key: 'X'},
                      {name: 'Access Cost', key: 'Z'}, {name: 'Access Price', key: 'Y'}, {name: 'Import', key: 'I'}, {name: 'Export', key: 'E'},
                      {name: 'Scan', key: 'N'}, {name: 'Download', key: 'Q'}, {name: 'Wipe Data', key: 'R'}, {name: 'Configure', key: 'G'}], //12
      selectedAccessRights: [],
      selectedProfile: "system_modules",
    //   serverType: "ho"
    }
  },
  watch: {
      accountId: async function(){
        //alert(this.accountId)
        this.availableLicense()
        this.componentKey++
      },
      selectedProfile: async function(){
        if (this.selectedProfile == 'pos_tracking_version'){
            await this.populateAccounts();
        }
      },
      selectedAccount: function() {
        if (!this.selectedAccount) { return; }

        this.selectedSite = null;
        if (this.selectedProfile == 'pos_tracking_version'){
          this.populateSites();
        }
      },
      selectedSite: function() {
        this.terminals = [];
        this.selectedTerminal = null;

        if (this.selectedSite) {
            this.populateTerminals();
        }
      },
      selectedTerminal: function(){
        this.componentKey++
      }
    },
  methods: {
    async handleSearch(value){
      this.fetching = true;
      var accounts = await HTTPRequest.getRequest(this.endPoint + "/accounts/get_valid_accounts?name=" + value , null, null)
      this.accountOptions = accounts
      this.fetching = false;
    },
    async populateAccounts() {
      // Get all Valid and Active accounts
      let accounts = await HTTPRequest.getRequest(`${this.endPoint}accounts/get_valid_accounts`, null, null)
      accounts = accounts.sort((a, b) => {
        const textA = a.account_name.toUpperCase();
        const textB = b.account_name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
      this.accounts = accounts || [];
    },
    async populateSites() {
      if (!this.selectedAccount) { return; }

      const sites = await HTTPRequest.getRequest(`${this.endPoint}sites/get_sites_with_terminal?account_id=${this.selectedAccount}`, null, null)
      this.sites = sites || [];
    },
    async populateTerminals() {
      const terminals = await HTTPRequest.getRequest(`${this.endPoint}terminals?account_id=${this.selectedAccount}&site_id=${this.selectedSite}`, null, null)
      this.terminals = (terminals || {}).data || [];
      this.terminals.push({id: 0, name: ' All Terminals'})
      this.selectedTerminal = 0;
    },
    async availableLicense(){
        if (this.selectedProfile == 'pos_tracking_version') { return; }
        var stats = await HTTPRequest.getRequest(this.endPoint + "licenses/get_stats?account_id=" + this.accountId , null)
        this.licenseStats =  stats["active_license"] +  "/" +  stats["no_of_license"]
    },
    async updateAvailableLicense(){
        this.availableLicense()
    },
    async availableLicense(){
        if (this.selectedProfile == 'pos_tracking_version') { return; }
        var stats = await HTTPRequest.getRequest(this.endPoint + "licenses/get_stats?account_id=" + this.accountId , null)
        this.licenseStats =  stats["active_license"] +  "/" +  stats["no_of_license"]
    },
    async updateAvailableLicense(){
        this.availableLicense()
    },
     newCateg(formId){
         this.selectedLevel = null
         this.showDrawer(formId)
     },
     refreshPage(){
        this.visible = false
        this.componentKey++
     },
    // MASS ACTIONS
    async massupdate(field_name,value){
        var field_update = {}
        field_update[field_name] = value
        var categoryPayload = {ids: this.checkedValues, field_update: field_update }
        var response = await HTTPRequest.postRequest(this.endPoint + '/system_modules/mass_update' , null, categoryPayload)
        if(response["message"] == "Ok"){
            this.onSelect(this.selectedNode)
            this.$notification['success']({
                message: 'Success',
                description: 'Update successful',
            });
        } else {
            this.$notification['error']({
                message: 'Error',
                description: 'Error processing',
            });
        }
    },

    // CHECKBOX MODULES
    onCheckChange(e){
        if(this.checkedValues.includes(e)){
            var indexValue = this.checkedValues.indexOf(e)
            this.checkedValues.splice(indexValue,1)
        } else {
            this.checkedValues.push(e)
        }
    },
    onCheckAllChange(){
        if(this.checkedValues.length == this.system_modules.length){
            this.checkedValues = []
        } else {
            this.checkedValues = this.system_modules.map(value => value.id)
        }
    },

    //CHECKBOX SYSTEM ACCESS
     onCheckChangeAccess(e){
        if(this.selectedAccessRights.includes(e)){
            var indexValue = this.selectedAccessRights.indexOf(e)
            this.selectedAccessRights.splice(indexValue,1)
        } else {
            this.selectedAccessRights.push(e)
        }
    },
    onCheckAllChangeAccess(){
        if(this.selectedAccessRights.length == this.accessRights.length){
            this.selectedAccessRights = []
        } else {
            this.selectedAccessRights = this.accessRights.map(value => value.key)
        }
    },

    // TOGGLE
    async toggleDetected( checked){
       var module_id = event.target.getAttribute("data-id")
       var modulePayload = {system_module: {enabled: checked} }
       await HTTPRequest.putRequest(this.endPoint + '/system_modules/' + module_id , null, modulePayload)
       this.onSelect(this.selectedNode)
    },

    // CRUD FUNCTIONS
    async updateData(){
        var categoryPayload = {system_module_category: {name: this.selectedTitle, code: this.selectedCode,
                               reference_code: this.selectedRefCode, status: 'A',
                               sequence_no: this.selectedSequence, icon: this.selectedIcon, endpoint: this.selectedEndpoint}
                              }
        // var categoryPayload = {system_module_category: {name: this.selectedTitle, code: this.selectedCode, reference_code: this.selectedRefCode} }
        this.gData = await HTTPRequest.putRequest(this.endPoint + '/system_module_categories/' + this.selectedKey , null, categoryPayload)
        gData = this.gData
        generateList(gData)

        if(gData['error'] != undefined) {

            this.$notification['error']({
                message: 'Opps',
                description: gData['error'],
            });
        } else {

            this.$notification['success']({
                message: 'Success',
                description: 'Update Successful',
            });
            this.onClose()
        }
    },
    async deleteData(){
        // Add Prompt here
        var categoryPayload = {system_module_category: {status: "D"} }
        this.gData = await HTTPRequest.putRequest(this.endPoint + '/system_module_categories/' + this.selectedKey , null, categoryPayload)
        gData = this.gData
        generateList(gData)
        this.clearData()
        this.$notification['success']({
                message: 'Success',
                description: 'Delete Successful',
            });
        this.onClose()
    },
    async createData(){
        if(this.selectedNode == null){
            this.selectedKey = "-1"
        }
        var categoryPayload = {system_module_category: {name: this.selectedTitle, code: this.selectedCode,
                               reference_code: this.selectedRefCode, status: 'A', parent_id: this.selectedKey,
                               sequence_no: this.selectedSequence, icon: this.selectedIcon, endpoint: this.selectedEndpoint}
                              }
        this.gData = await HTTPRequest.postRequest(this.endPoint + '/system_module_categories/' , null, categoryPayload)
        gData = this.gData
        generateList(gData)

        if(gData['error'] != undefined) {

            this.$notification['error']({
                message: 'Opps',
                description: gData['error'],
            });
        } else {

            this.$notification['success']({
                message: 'Success',
                description: 'Create Successful',
            });
            this.onSelect(this.selectedNode)
            this.clearData()
            this.onClose()
        }

    },
    async createModule(){
        var modulePayload = {system_module: {name: this.module.name, code: this.module.code,
                                reference_code: this.module.reference_code, sequence_no: this.module.sequence_no,
                                status: 'A', system_module_category_id: this.selectedKey,
                                description: this.module.description, created_by: "System"
                                }
                            }
        var res = await HTTPRequest.postRequest(this.endPoint + '/system_modules/' , null, modulePayload)

        if(res['error'] != undefined) {

            this.$notification['error']({
                message: 'Opps',
                description: res['error'],
            });
        } else {

            this.$notification['success']({
                message: 'Success',
                description: 'Create Successful',
            });
            this.onSelect(this.selectedNode)
            this.clearData()
            this.onClose()
        }

    },
    async updateModule(){
        if(this.selectedModule != null){
            var modulePayload = {system_module: {name: this.selectedModule.name, code: this.selectedModule.code,
                                reference_code: this.selectedModule.reference_code, sequence_no: this.selectedModule.sequence_no,
                                status: 'A', supported_rights: this.selectedAccessRights.join(","),
                                description: this.selectedModule.description
                                }
                            }
            await HTTPRequest.putRequest(this.endPoint + '/system_modules/' + this.selectedModule.id , null, modulePayload)
            this.onSelect(this.selectedNode)
            this.$notification['success']({
                message: 'Success',
                description: 'Update Successful',
            });
            this.clearData()
            this.onClose()
        }else{
            this.massupdate('supported_rights', this.selectedAccessRights.join(","))
            this.clearData()
            this.onClose()
        }


    },
    filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    editModule(formId, system_module){
        this.formId = formId
        this.visible = true
        this.selectedModule = system_module
        this.selectedAccessRights = system_module.supported_rights.split(",")
    },
    async deleteModule(){
        var modulePayload = {system_module: {status: "D"} }
        this.gData = await HTTPRequest.putRequest(this.endPoint + '/system_modules/' + this.selectedModule.id  , null, modulePayload)
        this.onSelect(this.selectedNode)
        this.$notification['success']({
            message: 'Success',
            description: 'Delete Successful',
        });
        this.clearData()
        this.onClose()
    },

    clearData(){
        this.selectedCode = null
        this.selectedRefCode = null
        this.selectedTitle = null
        this.selectedSequence = null
        this.selectedIcon = null
        this.selectedEndpoint = null
        this.selectedAccessRights = []
        this.module.name = null
        this.module.code = null
        this.module.sequence_no = null
        this.module.reference_code = null
        this.module.description = null
    },
    // DRAWERS
    showDrawer(formId) {
        this.formId = formId
        if(formId == 'addCategory'){
            this.clearData()
            this.visible = true
        } else if(formId == 'addModule'){
            this.module.sequence_no = this.system_modules.length + 1
            if(this.selectedNode.children.length == 0){
                this.visible = true
            } else {
                this.$notification['error']({
                    message: 'Error',
                    description: 'Cannot add modules to parent categories.',
                });
            }
        } else {
            this.visible = true
        }
    },
    onClose() {
      this.visible = false
      this.clearData()
    },

    // TREE FUNCTIONS
    onExpand  (expandedKeys) {
      this.selectedNode = null
      this.clearData()
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onChange (e) {
      const value = e.target.value
      const expandedKeys = dataList.map((item) => {
        if (item.title.indexOf(value) > -1) {
          return getParentKey(item.key, gData)
        }
        return null
      }).filter((item, i, self) => item && self.indexOf(item) === i)
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true,
      })
    },
    onCheck(info){
        console.log(info)
    },
    async onSelect(info){
        var selectedNode = getNode(info[0], gData)
        console.log(selectedNode)
        this.selectedNode = selectedNode
        this.selectedKey = selectedNode.key
        this.selectedCode = selectedNode.scopedSlots.code
        this.selectedRefCode = selectedNode.scopedSlots.reference_code
        this.selectedSequence = selectedNode.scopedSlots.sequence_no
        this.selectedIcon = selectedNode.scopedSlots.icon
        this.selectedEndpoint = selectedNode.scopedSlots.endpoint
        this.selectedLevel = selectedNode.scopedSlots.category_level
        this.selectedTitle = selectedNode.title
        this.checkedValues = []
        if(selectedNode.children.length == 0){
            var system_modules = await HTTPRequest.getRequest(this.endPoint + '/system_modules?system_module_category_id=' + this.selectedKey + "&status=A" , null)
            this.system_modules = system_modules
        } else {
            this.system_modules = []
        }
    },
    // eslint-disable-next-line
    onDragEnter (info) {
      // eslint-disable-next-line
    },
    async onDrop (info) {
        // eslint-disable-next-line
        var for_update = info.dragNode.$options.propsData.eventKey
        var new_parent = info.node.$options.propsData.eventKey
        var categoryPayload = {system_module_category: {parent_id: new_parent} }
        this.gData = await HTTPRequest.putRequest(this.endPoint + '/system_module_categories/' + for_update , null, categoryPayload)
        gData = this.gData
        generateList(gData)
    },
    ...mapActions(['updateCurrentProfile', 'updateParameters']),
    setCurrentProfile(profile){
        this.selectedProfile = profile
        if(profile == "terminals" || profile == "payment_types"){
            this.updateCurrentProfile(profile)
        } else if( profile == "terminal_settings" || profile == "terminal_template_settings"){
            this.componentKey++
        }
    },
    changeFilter(statusFilter, searchFilter, searchText){
      this.filterStatus = statusFilter
      if(statusFilter == "0"){
          console.log(this.parameters)
          this.updateParameters("?" + searchFilter + "=" + searchText )
          console.log(this.parameters)
      } else if( statusFilter == "A"){
          this.updateParameters("?" + searchFilter + "=" + searchText + "&status=A")
      } else {
          this.updateParameters("?" + searchFilter + "=" + searchText + "&status=I")
      }

    },
  },
}
</script>